export default class Meta {}

Meta.indicators = null;
